module.exports = __webpack_public_path__ + "media/KZ-ZHA.d96f4ab9.ogg";